export const fetchJson = async <T>(input: RequestInfo, init?: RequestInit) =>
  fetch(input, init).then(r => r.json() as Promise<T>)